var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-ai-training-design-detail" },
    [
      _c(
        "div",
        [
          _c(
            "yxt-button",
            {
              on: {
                click: function ($event) {
                  return _vm.$emit("goback")
                },
              },
            },
            [_vm._v("返回")]
          ),
          _c(
            "span",
            { staticClass: "pull-right" },
            [
              _c(
                "yxt-button",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading.fullscreen.lock",
                      value: _vm.fullscreenclear,
                      expression: "fullscreenclear",
                      modifiers: { fullscreen: true, lock: true },
                    },
                  ],
                  on: {
                    click: function ($event) {
                      return _vm.clearAll()
                    },
                  },
                },
                [_vm._v("一键清空")]
              ),
              _c(
                "yxt-button",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading.fullscreen.lock",
                      value: _vm.fullscreenexport,
                      expression: "fullscreenexport",
                      modifiers: { fullscreen: true, lock: true },
                    },
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.exportLearningMap },
                },
                [_vm._v("导出学习地图")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "yxt-container",
        { staticClass: "clearfix" },
        [
          _c(
            "yxt-aside",
            { staticClass: "mt24", attrs: { width: "150px" } },
            [
              _c("div", { staticClass: "color-gray-8" }, [
                _vm._v("点击下方步骤按钮，"),
                _c("br"),
                _vm._v("开始生成"),
              ]),
              _c(
                "yxt-menu",
                {
                  staticClass: "yxt-menu-vertical-demo",
                  attrs: { "default-active": _vm.defaultSelect },
                },
                _vm._l(_vm.leftData, function (item) {
                  return _c(
                    "yxt-menu-item",
                    {
                      key: item.value,
                      attrs: { index: item.value },
                      on: {
                        click: function ($event) {
                          return _vm.clickLeft(item)
                        },
                      },
                    },
                    [
                      _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                        _vm._v(_vm._s(item.name)),
                      ]),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "yxt-main",
            [
              _c(
                "div",
                { staticClass: "lh32 mb16 font-size-24 weight-medium" },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.data ? _vm.data.learningMapName : "-") +
                      "\n      "
                  ),
                ]
              ),
              _vm._l(_vm.resultData, function (item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "mb24" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "lh26 mb12 font-size-18 weight-medium",
                        class: "scrollInto" + item.id,
                      },
                      [
                        _vm._v(
                          "\n          任务" +
                            _vm._s(index + 1) +
                            "：" +
                            _vm._s(item.period) +
                            "\n        "
                        ),
                      ]
                    ),
                    item.tasks
                      ? _vm._l(item.tasks, function (itemChild, num) {
                          return _c(
                            "div",
                            { key: num },
                            _vm._l(_vm.leftData, function (letfItemChild) {
                              return _c(
                                "div",
                                {
                                  key: letfItemChild.value,
                                  staticClass: "layout-flex",
                                },
                                [
                                  itemChild[letfItemChild.value] ||
                                  (_vm.editSetect &&
                                    _vm.editSetect.taskid === itemChild.id &&
                                    _vm.editSetect.leftCode ===
                                      letfItemChild.value)
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "lh42 left-form-width mb18",
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(letfItemChild.name) +
                                                _vm._s(num + 1) +
                                                "：\n                "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "flex-1 mb18" },
                                          [
                                            _c("yxt-input", {
                                              attrs: {
                                                disabled: _vm.getDisable(
                                                  item,
                                                  itemChild,
                                                  letfItemChild,
                                                  num
                                                ),
                                                type: "textarea",
                                                autosize: "",
                                              },
                                              model: {
                                                value:
                                                  itemChild[
                                                    letfItemChild.value
                                                  ],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    itemChild,
                                                    letfItemChild.value,
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "itemChild[letfItemChild.value]",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "ml18 mb18 right-form-width lh42",
                                          },
                                          [
                                            _vm.getDisable(
                                              item,
                                              itemChild,
                                              letfItemChild,
                                              num
                                            )
                                              ? _c(
                                                  "yxt-button",
                                                  {
                                                    attrs: {
                                                      type: "text",
                                                      disabled: _vm.isDisable,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.edit(
                                                          item,
                                                          itemChild,
                                                          letfItemChild,
                                                          num
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("编辑")]
                                                )
                                              : [
                                                  _c(
                                                    "yxt-button",
                                                    {
                                                      attrs: { type: "text" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.save(
                                                            itemChild[
                                                              letfItemChild
                                                                .value
                                                            ]
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("保存")]
                                                  ),
                                                  _c(
                                                    "yxt-button",
                                                    {
                                                      attrs: { type: "text" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.cancel()
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("取消")]
                                                  ),
                                                ],
                                          ],
                                          2
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              )
                            }),
                            0
                          )
                        })
                      : _vm._e(),
                  ],
                  2
                )
              }),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        { ref: "aiboxRefdv" },
        [
          _vm.aiboxVisible
            ? _c("yxtbiz-aibox-unify", {
                ref: "aiboxRef",
                attrs: {
                  "app-id": _vm.appId,
                  "carry-parmas": _vm.carryParmas,
                  "api-map": _vm.apiMap,
                },
                on: {
                  close: function ($event) {
                    _vm.aiboxVisible = false
                  },
                  processEnd: _vm.processEnd,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }